import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {Role} from '../../data/models/role';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class RoleService {

  private rolesSubject = new BehaviorSubject<Role[]>([]);

  constructor(
    private http: HttpClient,
  ) {
  }

  get roles$(): Observable<Role[]> {
    if (this.rolesSubject.getValue().length === 0) {
      this.fetchRoles()
        .then(roles => this.rolesSubject.next(roles));
    }
    return this.rolesSubject.asObservable();
  }

  fetchRoles(): Promise<Role[]> {
    return this.http.get<Role[]>(`api/roles`)
      .toPromise()
      .catch(error => {
        this.rolesSubject.next([]);
        return [];
      });
  }
}
